import { render, staticRenderFns } from "./ConfigStatus.vue?vue&type=template&id=64d7908a&scoped=true&"
import script from "./ConfigStatus.vue?vue&type=script&lang=js&"
export * from "./ConfigStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d7908a",
  null
  
)

export default component.exports